// extracted by mini-css-extract-plugin
export var actionText = "_m9-4";
export var container = "_m9-0";
export var leftSection = "_m9-1";
export var rightSection = "_m9-2";
export var settingsButton = "_m9-6";
export var settingsIcon = "_m9-7";
export var shortcut = "_m9-5";
export var shortcutGroup = "_m9-3";